export var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus[ReservationStatus["RESERVATION_PENDING"] = 0] = "RESERVATION_PENDING";
    ReservationStatus[ReservationStatus["RESERVATION_CONFIRMED"] = 1] = "RESERVATION_CONFIRMED";
    ReservationStatus[ReservationStatus["RESERVATION_CANCELED"] = 2] = "RESERVATION_CANCELED";
    ReservationStatus[ReservationStatus["RESERVATION_CANCELED_MANUALLY"] = 3] = "RESERVATION_CANCELED_MANUALLY";
    ReservationStatus[ReservationStatus["RESERVATION_EXPIRED"] = 4] = "RESERVATION_EXPIRED";
    ReservationStatus[ReservationStatus["RESERVATION_PREVIEW"] = 5] = "RESERVATION_PREVIEW";
})(ReservationStatus || (ReservationStatus = {}));
